export default "__VITE_ASSET__eddf1eb1__"